import styled from 'styled-components'
import { primaryColor, primaryFont, wMedium, secondaryFont, primaryHeadingColor, scrollbar, SecondaryColor } from '../../../Utils/utilsStyle';
import { Executive } from '../../../Types/PersonTypes';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../Slice/PersonProfileSlice';
import { actions as companyActions } from '../../../Slice/CompaniesSlice';
import classNames from 'classnames';
import InfiniteScroll from 'react-infinite-scroll-component';
import { selectNotableStaff, selectNotableStaffCount, selectNotableStaffLoading, selectNotableStaffPage } from '../../../Selector/CompaniesSelector';
import AffinitySearchResultItemSkeleton from '../../common/skeleton/AffinitySearchResultItemSkeleton';
import { selectAffinitySelectedPersonId } from '../../../Selector/AffinitySearchSelector';
import { useEffect, useState } from 'react';
import { SalesAlignmentItem } from '../../../Types/GlobalTypes';
import { selectAlignmentPeopleStaff } from '../../../Selector/PersonProfileSelector';
import AlignmentPopoverList from './AlignmentPopoverList';
const ContentWrapper = styled.div`
  border-radius: 14px;
  background: #FFF;
  height: 270px;
  width: 230px;
  &.noStaff {
    .empty-list {
      width: 100%;
      height: 80%;
    }
  }
`;
type Props = {
  personsList: SalesAlignmentItem[];
  basePersonId: number
  rowId: number;
  currentCompanyId: number;
  closePopover: () => void;
};
const defaultProps = {
  personsList: [],
  basePersonId: 0,
  rowId: 0,
  currentCompanyId: 0,
};

const SalesAlignmentPopover = function SalesAlignmentPopover(props: Props) {
  const {
    personsList, basePersonId, rowId, currentCompanyId, closePopover } = props;
  const [query, setQuery] = useState('');
  const dispatch = useDispatch();
  const alignmentStaff = useSelector(selectAlignmentPeopleStaff(rowId));
  const { page: staffPage, count: totalStaff, loading: staffLoading, staff: staffData } = alignmentStaff;
  const personIds = personsList.map(item => item.person.personId);
  const disabledIds = [...personIds, basePersonId];

  const getSalesAlignment = (addedPersonId: number) => {
    // Adding people one-by-one: send only the newly added person id in `personId`.
    // `personIds` must NOT be included here; it is reserved for affinity-person change only.
    dispatch(actions.getMultipleSalesAlignment({
      personId: addedPersonId,
      rowId,
      ...(rowId > 0 && { affinityPerson: basePersonId }),
    }));

    closePopover();
  }

  const onSearching = (q: string) => {
    setQuery(q);
    if (currentCompanyId !== 0) {
      dispatch(actions.addAlignmentPeople({
        query: q,
        companyId: currentCompanyId,
        page: 1,
        screenName: 'multiSales',
        rowId: rowId
      }));
    }
  };

  const fetchMoreStaff = () => {
    if (currentCompanyId !== 0) {
      dispatch(actions.addAlignmentPeople({
        companyId: currentCompanyId,
        page: staffPage,
        query,
        screenName: 'multiSales',
        rowId: rowId
      }));
    }
  };
  return (
    <ContentWrapper
      className={classNames("sales-alignment-popover", {
        noStaff: staffData.length === 0,
      })}
    >
      <AlignmentPopoverList
        staff={staffData}
        totalStaff={totalStaff}
        loading={staffLoading}
        disabledIds={disabledIds}
        onSelect={getSalesAlignment}
        onFetchMore={fetchMoreStaff}
        onSearching={onSearching}
        query={query}
        scrollContainerId={`scrollPeople-multisales-${rowId}`}
      />
    </ContentWrapper >
  );
};

SalesAlignmentPopover.defaultProps = defaultProps;
export default SalesAlignmentPopover;
